import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'actions';
import selectors from 'selectors';
import useMedia from 'hooks/useMedia';
import { redactionTypeMap } from 'constants/redactionTypes';
import useCore from 'hooks/useCore';
import DataElements from 'constants/dataElement';
export default function useOnRedactionAnnotationChanged() {
  const { core } = useCore();
  const [redactionAnnotationsList, setRedactionAnnotationsList] = useState([]);
  const dispatch = useDispatch();
  const isMobile = useMedia(
    // Media queries
    ['(max-width: 640px)'],
    [true],
    // Default value
    false,
  );

  const isNotesPanelOpen = useSelector((state) => selectors.isElementOpen(state, DataElements.NOTES_PANEL));
  const isSearchPanelOpen = useSelector((state) => selectors.isElementOpen(state, DataElements.SEARCH_PANEL));

  useEffect(() => {
    const setRedactionAnnotations = () => {
      const redactionAnnotations = core.getAnnotationsList().filter((annotation) => annotation instanceof window.Core.Annotations.RedactionAnnotation);
      const mediaAnnotationTypes = [
        redactionTypeMap['FULL_VIDEO_FRAME'],
        redactionTypeMap['FULL_VIDEO_FRAME_AND_AUDIO'],
        redactionTypeMap['AUDIO_REDACTION'],
      ];
      setRedactionAnnotationsList(redactionAnnotations);

      const nonMediaRedactionAnnotations = redactionAnnotations.filter((annotation) => !mediaAnnotationTypes.includes(annotation.redactionType));

      if (nonMediaRedactionAnnotations.length > 0 && !isMobile) {
        // Initially the state will be undefined, so we cast to boolean and negate it
        const isNotesPanelClosed = !isNotesPanelOpen;
        const isSearchPanelClosed = !isSearchPanelOpen;

        if (isNotesPanelClosed && isSearchPanelClosed) {
          dispatch(actions.openRedactionPanel());
        }
      }
    };

    const onDocumentLoaded = () => {
      setRedactionAnnotationsList([]);
    };

    core.addEventListener('documentLoaded', onDocumentLoaded);
    core.addEventListener('annotationChanged', setRedactionAnnotations);

    return () => {
      core.removeEventListener('documentLoaded', onDocumentLoaded);
      core.removeEventListener('annotationChanged', setRedactionAnnotations);
    };
  }, [isNotesPanelOpen, isSearchPanelOpen, core]);

  // We should update the redaction annotations list when the active document viewer changes
  useEffect(() => {
    const redactionAnnotations = core.getAnnotationsList().filter((annotation) => annotation instanceof window.Core.Annotations.RedactionAnnotation);
    setRedactionAnnotationsList(redactionAnnotations);
  }, [core]);

  return { redactionAnnotationsList };
}